<template>
  <div class="detailBox">
    <div
      style="position: absolute; z-index: 400;"
      :style="{
        left: form.x + 50 + 'px',
        top: form.y - 111 + 'px'
      }"
      class="content-box"
    >
      <div class="warn">
        <div class="title">{{ town }}</div>
        <ul>
          <li class="list-li" v-for="(item, i) in dataList" :key="i">
            <span class="point"></span>
            {{ item.name }}：
            <span class="num">{{ item.num }}</span>
            <span class="unit">({{ item.unit }})</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: Object
  },
  data() {
    return {
      town: "",
      dataList: [
        {
          name: "行政区域面积",
          num: 260.44,
          unit: "平方公里"
        },
        {
          name: "户籍人口数",
          num: 99332,
          unit: "人"
        },
        {
          name: "全镇生产总值",
          num: 153523,
          unit: "万元"
        },
        {
          name: "人均可支配收入",
          num: 0,
          unit: "万元"
        },
        {
          name: "相对贫困村数",
          num: 14800,
          unit: "个"
        },
        {
          name: "相对贫困人口数",
          num: 14800,
          unit: "人"
        }
      ]
    };
  },
  mounted() {
    this.setFormData(this.form.param);
  },
  methods: {
    getData(data) {
      this.$forceUpdate();
      this.$set(this.form, data);
      this.setFormData(data.param);
    },
    setFormData(param) {
      this.town = param.town;
      this.dataList[0].num = param.administrative_area;
      this.dataList[1].num = param.hjrks;
      this.dataList[2].num = param.qzdqsczz;
      this.dataList[3].num = param.qznmrjkzpsr;
      this.dataList[4].num = param.xdpkcs;
      this.dataList[5].num = param.xdpkrks;
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.detailBox
  z-index 10
  color #fff
.content-box
    :before
        width 52px
        height 66px
        content ''
        position absolute
        top 20%
        left 0
        margin-left -52px
        background url('~images/map/task-line.png') no-repeat center
        background-size 100% 100%
.warn
    width 284px
    height 224px
    border-radius 5px
    box-sizing border-box
    position relative
    background url('~images/map/task-bg.png') no-repeat center
    background-size 100% 100%
//   transform translate(-52%, -192%)
    z-index 400
    :before
        content ''
        transform translate(-35%,0)
        position absolute
        bottom -9px
        left 50%
        opacity 1
        border-top solid 10px rgba(51,51,51,0.7)
        border-right solid 10px transparent
        border-left solid 10px transparent
.list-li
    font-size 14px
    padding-left 20px
    margin-top 6px
    .point
        display inline-block
        width 6px
        height 6px
        background-color #fff
        border-radius 50%
        margin-right 4px
    .num
        font-size 22px
        color #00f8fa
        margin-right 10px
.title
    width 254px
    height 40px
    line-height 40px
    padding-left 20px
    font-size 16px
    display block
    background url('~images/map/task-title-bg.png') no-repeat center
    background-size 100% 100%
</style>
